import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '@sbd-doug-frontend/app/shared/shared.module';
import { LongListModule } from '@sbd-doug-frontend/shared/lib/ui/longlist/longlist.module';
import { FilterModule } from '@sbd-doug-frontend/shared/lib/ui/filter/filter.module';
import { MaterialModule } from '@sbd-doug-frontend/app/shared/material.module';

const routes: Routes = [
  {
    path: 'requests',
    loadChildren: () => import('./request/request.module').then(m => m.QuoteRequestModule)
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes), LongListModule, FilterModule, MaterialModule,
  ],
  exports: [RouterModule, SharedModule]
})
export class QuotesRoutingModule { }
